<div class="load-payment">
  <div [class.rotating]="inProgress"></div>
  <p class="load-payment-error" *ngIf="errorMessage" [innerHTML]="errorMessage | cxTranslate"></p>
</div>
